import React, { useState } from "react";
import PropTypes from "prop-types";
import classes from "./input.module.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";

/**
 * Primary UI component for user interaction
 */
export const Input = ({
  type,
  label,
  state,
  setter,
  noBorder,
  placeholder,
  disabled,
  customStyle,
  inputStyle,
  error,
  errorText,
  label2,
  inputRef,
  ...props
}) => {
  const [passToggle, setPassToggle] = useState(false);
  let inputContainerStyleObject = Object.assign(
    {},
    error && { border: `1px solid ${Colors.mainShadeOfRed} ` }
  );
  return (
    <>
      <style jsx>{`
        .${classes.labelText} {
          color: ${error
            ? Colors.neutralShadesOfDimGray
            : Colors.neutralShadesOfNero};
          font-size: ${Fonts.input2.fontSize};
          line-height: 16px;
          font-family: ${Fonts.input2.fontFamily};
        }
        .${classes.disabled} {
          color: ${Colors.neutralShadesOfPinkSwan};
        }
        .${classes.inputBox} {
          border: 1px solid ${Colors.neutralShadesOfGainsboro};
          font-size: ${Fonts.p1.fontSize};
          line-height: ${Fonts.p1.lineHeight};
          font-family: ${Fonts.p1.fontFamily};
          padding: ${type == "password"
            ? "12px 45px 12px 16px"
            : "12px 16px 12px 16px"};
          height: 100%;
        }
        .${classes.inputBox}::placeholder {
          color: ${Colors.neutralShadesOfDimGray};
        }
        .${classes.inputBox}:hover {
          border: 1px solid ${Colors.neutralShadesOfNero};
        }
        .${classes.inputBox}:focus {
          border: 1px solid ${Colors.neutralShadesOfNero};
        }
        .${classes.inputBox}:active {
          border: 1px solid ${Colors.neutralShadesOfNero};
        }
        .${classes.inputBox}:disabled {
          background-color: 1px solid ${Colors.neutralShadesOfWhiteSmoke};
          color: ${Colors.neutralShadesOfPinkSwan};
          border: 1px solid ${Colors.neutralShadesOfGainsboro};
        }
        .${classes.inputBox}:disabled::placeholder {
          color: ${Colors.neutralShadesOfPinkSwan};
        }
        .${classes.errorText} {
          font-size: ${Fonts.p4.fontSize};
          font-family: ${Fonts.p4.fontFamily};
          line-height: ${Fonts.p4.lineHeight};
          color: ${Colors.errorColor};
        }
      `}</style>
      <div
        className={`${[classes.Container].join(" ")}`}
        style={{ ...customStyle }}
      >
        {label && (
          <label
            htmlFor={`input${label}`}
            className={`mb-2  ${[
              classes.labelText,
              disabled && classes.disabled,
            ].join(" ")}`}
            style={{
              ...Fonts.input2,
              color: Colors.neutralShadesOfNero,
              lineHeight: "16px",
            }}
          >
            {label} {label2 && label2}
          </label>
        )}
        <div className={`${[classes.inputPassContainer].join(" ")}`}>
          <input
            value={state}
            onChange={(e) => {
              setter(e.target.value);
            }}
            disabled={disabled}
            placeholder={placeholder}
            type={passToggle == true ? "text" : type}
            id={`input${label}`}
            className={` ${[
              classes.inputBox,
              noBorder && classes.noBorder,
            ].join(" ")}`}
            style={{ ...inputContainerStyleObject, ...inputStyle }}
            autoComplete="off"
            // style={{padding:type == "password" ? '12px 45px 12px 16px' : '12px 16px 12px 16px', ...inputContainerStyleObject, ...inputStyle,  }}
            ref={inputRef}
            {...props}
          />
          {type == "password" && passToggle == false && (
            <VisibilityOffIcon onClick={(e) => setPassToggle(!passToggle)} />
          )}
          {type == "password" && passToggle && (
            <VisibilityIcon onClick={(e) => setPassToggle(!passToggle)} />
          )}
        </div>
        {error && (
          <p className={`mt-2 ${[classes.errorText].join(" ")}`}>{errorText}</p>
        )}
      </div>
    </>
  );
};

Input.propTypes = {
  type: PropTypes.oneOf.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  state: PropTypes.string.isRequired,
  setter: PropTypes.string,
  noBorder: PropTypes.bool,
  disabled: PropTypes.bool,
  customStyle: PropTypes.string,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  label2: PropTypes.string,
};

Input.defaultProps = {
  type: "text",
  placeholder: "Enter Text",
  state: "",
  noBorder: false,
  disabled: false,
  error: false,
  errorText: "An error has occurred, check your details!",
};
